import { IShoppingItem } from "../../types/shoppingList";
import { deleteApi, getApi, postApi } from "../api";
import { ShoppingListDb } from "../indexeddb/shoppingListDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class ShoppingListStore {
  private static instance: ShoppingListStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new ShoppingListDb();
  public shoppingList: IShoppingItem[] = [];
  public shopSections: string[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): ShoppingListStore {
    if (!ShoppingListStore.instance) {
        ShoppingListStore.instance = new ShoppingListStore();
    }
    return ShoppingListStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
  }

  public async getShoppingList(startDate: string, endDate: string, clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getList();
      if (local.length == 0 || clear) {
        const api = await getApi(apiUrl, "shoppinglist", apiToken, { date: `between.${startDate}_${endDate}` });
        await this.db.addList(api, clear);
        this.shoppingList = api;
      } else {
        this.shoppingList = local;
      }
      this.shopSections = [...new Set(this.shoppingList.map((item: IShoppingItem) => item.shop_section))] as string[];
    } catch (e: any) {
      console.log(e);
    }
  }

  public async addExtraShoppingListItem(ingredient_name: string, quantity: number, unit_suffix: string): Promise<void> {
    try {
      await postApi(apiUrl, "shoppinglist", {ingredient_name, quantity, unit_suffix}, apiToken);
    } catch (e: any) {
      console.log(e);
      throw e;
    }
  }

  public async clearAllShoppingListItems(): Promise<void> {
    try {
      await deleteApi(apiUrl, "shoppinglist", undefined, apiToken);
    } catch (e: any) {
      console.log(e);
      throw e;
    }
  }
}
